var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"bottomNavBar"},[_c('div',{staticClass:"menuButton",on:{"click":function($event){_vm.toggleSidebar(); _vm.animateButtonClick($event)}}},[_c('i',{staticClass:"fa fa-bars"}),_c('p',[_vm._v("Menu")])])])}
var staticRenderFns = []

export { render, staticRenderFns }